export default __webpack_public_path__ + "static/media/q26_step3.94f9242d.png";